<template>
<collection @sorting="sorting" @itemDelete="itemDelete" :loading="loading" v-bind="data.id" :data="data" :structure="structure" :has_searched="has_searched" :params="params" model="project"></collection>
</template>
<script>
import Collection from '@/components/helpers/DataDisplay/Collection'
import CrmStatus from '@/components/helpers/DataDisplay/CollectionValues/CollectionValueCrmStatus'
import DeleteAction from '@/components/helpers/DataDisplay/CollectionValues/CollectionValueCrudActionFolded'
import ProgressBar from '@/components/helpers/DataDisplay/ProgressBar'

export default{
  components: {Collection, CrmStatus, DeleteAction, ProgressBar},
  props: [ 'loading', 'data', 'structure', 'id', 'params', 'has_searched' ],
  methods: {
    sorting(payload){
      this.$emit('sorting',payload)
    },
    itemDelete(payload){
      this.$emit('itemDelete',payload)
    },
    date(date){
      return moment(date).format("DD.MM.YYYY")
    }
  },
  computed: {
    actionDeleteColumn(){
      return _.find(this.structure, {name: 'action'});
    }
  }
}
</script>



// WEBPACK FOOTER //
// ProjectsListing.vue?703a1f5d